module.exports = __webpack_public_path__ + "static/media/campaignSkeletonSm.0b387190.svg";